import { isSyntheticOpener } from './coach/opener-intent';
import { messageText } from './message-text';
import type { PlannerUIMessage } from './types';

/**
 * Takes the couple's last message out of the thread, with anything after it, so a failed
 * turn can be edited and sent again. Returns the shorter thread and the text to put back in
 * the composer. The hidden opener was never typed, so its draft is empty.
 */
export const takeLastUserMessage = (
  messages: readonly PlannerUIMessage[],
): { messages: PlannerUIMessage[]; draft: string } | null => {
  // Searched from the end: the couple's message is usually the last one.
  let index = messages.length - 1;
  while (index >= 0 && messages[index].role !== 'user') index -= 1;
  if (index < 0) return null;
  const message = messages[index];
  return {
    messages: messages.slice(0, index),
    draft: isSyntheticOpener(message) ? '' : messageText(message),
  };
};
